import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Http, Response, Headers, RequestOptions, ResponseContentType } from '@angular/http';
import { HttpParams } from  '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { CookieService } from 'ngx-cookie';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { CommonUtilService } from '../services/common.service';
import * as moment from 'moment';
declare var DDP_ENV: any;

@Injectable({
	providedIn: 'root'
})
export class ChartOffsetCalculator {
	base_url = DDP_ENV.baseUrl;
	threshold = 1000;
	dataStreamOffsets = [];
	isCheckRunning = true;
	prevMaxOffset = 0;
	constructor(private _router: Router, private _http: Http, private cookieService: CookieService
		, private commonUtilService: CommonUtilService) {
		this.checkAliveDataStreams();
	}

	checkAliveDataStreams() {
		if (!this.isCheckRunning) {
			return;
		}
		const now = new Date().getTime();
		this.dataStreamOffsets.forEach(function(value, key) {
			if (value.lastUpdate < now - 5000) {
				delete(this.dataStreamOffsets[key]);
			}
		});
		// schedule recursive call
		setTimeout(() => {
			this.checkAliveDataStreams();
		}, 1000	);
	}

	now() {
		return moment().toDate().getTime();
	}

	setOffset(offset, dataStream) {
		this.dataStreamOffsets[dataStream] = {offset: offset, lastUpdate: new Date().getTime()};
	}

	getOffset(dataStream) {
		return this.dataStreamOffsets[dataStream] ? this.dataStreamOffsets[dataStream].offset : 0;
	}

	getMaxOffset() {
		const offsets = this.dataStreamOffsets.map(function(item) {
			return item.offset;
		});
		return offsets.length > 0 ? Math.max(...offsets) : 0;
	}

	/* TODO: Doubtful */
	subscribe(scope, callback) {
		// let handler = this.on('offset-changed-event', callback);
		// this.on('destroy', handler);
	}

	computeOffset(dataStream, timestamp) {
		const dt = this.now() - timestamp;
		const offset = this.getOffset(dataStream);

		if (dt > 0 && Math.abs(offset - dt) > this.threshold) {
			this.setOffset(dt, dataStream);
		}

		const maxOffset = this.getMaxOffset();
		if (this.prevMaxOffset != maxOffset) {
			// $rootScope.emit('offset-changed-event', maxOffset);
			this.prevMaxOffset = maxOffset;
		}
	}


}
